import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import CheckboxSvg from 'images/v5/icons/circle/checkbox.svg';
import ExclamationSvg from 'images/v5/icons/circle/exclamation.svg';
import InformationSvg from 'images/v5/icons/circle/information.svg';
import WarningSvg from 'images/v5/icons/circle/warning.svg';
import CloseSvg from 'images/v5/icons/x-close.svg';
import Button from 'layout/atoms/Button/Button';
import { removeToast } from 'store/toastsSlice';
import styles from './Toast.module.scss';
function Toast({ id, theme = 'inverse', color, noIcon = false, autoClose = true, title, description, }) {
    const dispatch = useDispatch();
    const [isActive, setIsActive] = useState(false);
    const [isLeaving, setIsLeaving] = useState(false);
    const wrapClasses = classNames(styles.wrap, styles[theme], styles[color], {
        [styles.withDescription]: description,
        [styles.isActive]: isActive,
    });
    const slotClasses = classNames(styles.slot, { [styles.isLeaving]: isLeaving });
    const defaultIcons = {
        negative: React.createElement(ExclamationSvg, null),
        notice: React.createElement(WarningSvg, null),
        positive: React.createElement(CheckboxSvg, null),
        info: React.createElement(InformationSvg, null),
        neutral: React.createElement(InformationSvg, null),
    };
    useEffect(() => {
        const timeoutId = setTimeout(() => setIsActive(true), 100);
        return () => clearTimeout(timeoutId);
    }, []);
    const handleClose = () => {
        setIsActive(false);
        setTimeout(() => setIsLeaving(true), 300);
        setTimeout(() => dispatch(removeToast(id)), 600);
    };
    useEffect(() => {
        if (!autoClose)
            return undefined;
        const autoCloseTimeoutId = setTimeout(() => handleClose(), 5000);
        return () => clearTimeout(autoCloseTimeoutId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [autoClose]);
    return (React.createElement("div", { className: slotClasses },
        React.createElement("div", { className: wrapClasses },
            React.createElement("header", { className: styles.header },
                React.createElement("h2", { className: styles.headerText },
                    !noIcon && defaultIcons[color],
                    React.createElement("p", null, title)),
                React.createElement(Button, { size: "xs", theme: "ghost", color: "inverse", shape: "rounded", leftIcon: React.createElement(CloseSvg, null), onClick: handleClose })),
            description && React.createElement("p", null, description))));
}
export default Toast;
